import { dbPrep, dbStrikePrep, locksetASAPrep } from "../PrepMenuOptions";
import { orderByAscending } from "nate-react-api-helpers";
import { getSpecialtyHingePrepLocation } from "../../../../logistics/warehouse/InventoryFrameTable";
export function prepsGetCategorySorted(p) { const autoSort = (key, isHinge) => { if (isHinge) {
    return 0;
} switch (key) {
    case locksetASAPrep: return 1;
    case "161": return 1;
    case dbStrikePrep: return 2;
    case dbPrep: return 2;
    case "RP": return 3;
} return 1000; }; let list = []; for (let k in p) {
    const v = p[k];
    if (v.type === "custom") {
        list.push({ key: k, value: v, sort: v.productCategorySort || 1000 });
    }
    else if (v.type === "standard") {
        list.push({ key: k, value: v, sort: autoSort(k, v.isHinge) });
    }
    else if (v.type === "unequalPairDoorSizes") {
        list.push({ key: k, value: v, sort: 0 });
    }
} orderByAscending(list, v => v.sort); return list; }
export function formatPreps(input, kind) { if (!input)
    return ""; if (typeof input === "string")
    return input; let list = []; let active = []; let inactive = []; let other = []; let door = []; let unequal = null; prepsGetCategorySorted(input).forEach(v => { let name = null; let frameSide = null; if (v.value.type === "custom") {
    name = v.value.productName || `<missing name:id=${v.value.product}>`;
    if (v.value.degreesOfOpening) {
        name += ` @ ${v.value.degreesOfOpening}°`;
    }
    frameSide = v.value.frameSide || "other";
}
else if (v.value.type === "standard") {
    name = v.key;
    frameSide = v.value.frameSide || "other";
}
else if (v.value.type === "unequalPairDoorSizes") {
    unequal = "Unequal pair (active=" + v.value.activeDoorWidth + ", " + v.value.inactiveDoorWidth + ")";
} if (name) {
    if (kind === "frame") {
        if (frameSide === "active") {
            active.push(name);
        }
        else if (frameSide === "inactive") {
            inactive.push(name);
        }
        else {
            other.push(name);
        }
    }
    else {
        door.push(name);
    }
} }); if (unequal) {
    list.push(unequal);
} if (active.length > 0) {
    list.push("Active side: " + active.join(", "));
} if (inactive.length > 0) {
    list.push("Inactive side: " + inactive.join(", "));
} if (other.length > 0) {
    list.push(other.join(", "));
} if (door.length > 0) {
    list.push(door.join(", "));
} const locs = getSpecialtyHingePrepLocation(input); if (locs) {
    list.push(`Specialty Hinge Prep at ${locs.display}`);
} if (list.length > 0) {
    return list.join("; ");
} return "BLANK"; }
export function prepsGetHinge(p) { for (const key in p) {
    const v = p[key];
    if (v.type === "standard" && v.isHinge) {
        return { key, value: v };
    }
} return undefined; }
